import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface CountdownProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
}
export function Countdown({
  initialHours = 23,
  initialMinutes = 49,
  initialSeconds = 42
}: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        }
        if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 text-2xl md:text-4xl font-bold font-display text-pistachio-800" data-id="element-345" data-mp="2c86rv0tmln2d">
      <TimeUnit value={format(timeLeft.hours)} label="hs" data-id="element-346" data-mp="2h5faf2iort45" />
      <span className="text-pistachio-300 pb-6" data-id="element-347" data-mp="2l8ldy2eez66x">:</span>
      <TimeUnit value={format(timeLeft.minutes)} label="min" data-id="element-348" data-mp="2l8v8826hrzif" />
      <span className="text-pistachio-300 pb-6" data-id="element-349" data-mp="2q7ojdnyb3eff">:</span>
      <TimeUnit value={format(timeLeft.seconds)} label="seg" data-id="element-350" data-mp="2q52czrn5j4ys" />
    </div>;
}
function TimeUnit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-351" data-mp="1xjkbqww6cra3">
      <div className="bg-surface border border-line rounded-lg p-3 min-w-[70px] md:min-w-[90px] text-center shadow-sm" data-id="element-352" data-mp="22hu9nf9aa5ze">
        <motion.span key={value} initial={{
        y: 10,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} className="block" data-id="element-353" data-mp="2793y4cj3j39p">
          {value}
        </motion.span>
      </div>
      <span className="text-xs text-muted mt-2 uppercase tracking-wider font-sans font-medium" data-id="element-354" data-mp="1er80fknjmfnt">
        {label}
      </span>
    </div>;
}